import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import {Checkbox} from 'rmwc';

import * as styles from '../../styles';
import {imageUrl} from '../../utilities/requests';
import {backgroundRequest, request} from '../../containers/actions';
import * as actions from './actions';
import { Radio } from 'rmwc';

const now = new window.MomentJalali();
if (now.jMonth() < 5)
    now.add(-1, 'jYear');
now.jMonth(5);
now.startOf('jMonth');
// let currentYear = Math.floor(now.toDate().getTime() / 1000);
// now.add(1, 'jYear');
// currentYear += ',' + Math.floor(now.toDate().getTime() / 1000);

let currentYear = (now.toDate().getTime() / 1000 + 12600 );
now.add(1, 'jYear');
currentYear += ',' + (now.toDate().getTime() / 1000 + 12600) ;

class Paper extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    constructor(props) {
        super(props);
        let answers;
        if (this.props.mode === 1) {
            answers = this.props.store.getIn(['data', 'answers'])
                ? this.props.store.getIn(['data', 'answers']).toJS()
                : Array(300).fill(0);
            answers = [...answers, ...Array(300 - answers.length).fill(0)];
        }
        else
            answers = this.props.store.get('data') ? this.props.store.getIn(['data', 'answers']).toJS() : undefined;
        this.state = {
            ...this.props.store.get('data') ? this.props.store.get('data').toJS() : null,
            currentYear: true,
            answers,
            examinations: [],
            studentSearch: '',
            typing: false,
            typingTimeout: 0
        };
    }

    componentDidMount() {
        this.fetchExaminations();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.store.get('data') && this.props.store.getIn(['data', 'id']) && !nextProps.store.getIn('data', 'id'))
            this.setState({answers: Array(300).fill(0)});
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.store.get('data') && 
            (!this.props.loader || this.props.store.getIn(['data', 'id'])) && (
                this.props.store.getIn(['data', 'id']) !== prevProps.store.getIn(['data', 'id']) ||
                this.props.store.getIn(['data', 'hash']) !== prevProps.store.getIn(['data', 'hash']) ||
                this.props.store.getIn(['data', 'answers']) !== prevProps.store.getIn(['data', 'answers']) ||
                this.props.mode !== prevProps.mode
            )
        ) {
            let answers;
            if (this.props.mode === 1) {
                answers = this.props.store.getIn(['data', 'answers'])
                    ? this.props.store.getIn(['data', 'answers']).toJS()
                    : Array(300).fill(0);
                answers = [...answers, ...Array(300 - answers.length).fill(0)];
            }
            else
                answers = this.props.store.getIn(['data', 'answers']).toJS();
            this.setState({
                student: null,
                examination: null,
                examinations: this.props.store.getIn(['data', 'examination']) ? this.state.examinations : [],
                ...this.props.store.get('data').toJS(),
                answers,
            });
        }
        else if (
            this.props.loader &&
            this.props.store.getIn(['data', 'id']) &&
            (
                (this.state.examination || {}).id !== this.props.store.getIn(['data', 'examination', 'id']) ||
                (this.state.student || {}).id !== this.props.store.getIn(['data', 'student', 'id'])
            )
        ) {
            this.context.store.dispatch([
                actions.setData(
                    {id: undefined},
                    this.props.store.get('elementId'),
                ),
                actions.load(
                    {
                        student: undefined,
                        examination: undefined,
                        page: undefined,
                    },
                    this.props.store.get('elementId'),
                ),
            ]);
        }
        if (this.state.currentYear !== prevState.currentYear || this.state.student !== prevState.student)
            this.fetchExaminations();
    }

    async fetchExaminations() {
        if (!this.state.student)
            return;
        let examinations;
        if (this.props.loader) {
            const response = await this.context.store.dispatch(request({
                path: '/examination/?' +
                `${this.props.mode === 1
                    ? 'multiple_choice_paper'
                    : 'paper'
                }s__student=` +
                `${this.state.student.id}&date__range=${this.state.currentYear
                    ? currentYear
                    : ''
                }&${this.props.mode === 1
                    ? 'multiple_choice_paper'
                    : 'paper'
                }s__online=False&limit=200&react__route=${window.location.pathname}`,
            }));
            examinations = response.results;
        }
        else if (this.state.student && this.state.student.grade) {
            let [registeredExaminations, allExaminations] = await this.context.store.dispatch([
                request({
                    path: '/examination/?' +
                    `${this.props.mode === 1
                        ? 'multiple_choice_paper'
                        : 'paper'
                    }s__student=${this.state.student.id}&date__range=${this.state.currentYear
                        ? currentYear
                        : ''
                    }&${this.props.mode === 1
                        ? 'multiple_choice_paper'
                        : 'paper'
                    }s__online=False&limit=200&react__route=${window.location.pathname}`,
                }),
                request({
                    path:this.props.mode === 1 ? `/examination/?grades=${this.state.student.grade.id}&type=${this.props.mode}&date__range=${this.state.currentYear
                        ? currentYear
                        : ''
                    }&limit=200&react__route=${window.location.pathname}`: `/examination/?registrations__student=${this.state.student.id}&type=${this.props.mode}&date__range=${this.state.currentYear
                        ? currentYear
                        : ''
                    }&limit=200&react__route=${window.location.pathname}`,
                }),
            ]);
            registeredExaminations = await registeredExaminations;
            allExaminations =  await allExaminations;
            if(allExaminations.length===0){
                allExaminations=registeredExaminations;
            }
            examinations = _.sortBy(
                allExaminations.results,
                examination => _.some(registeredExaminations.results, e => e.id === examination.id) ? 0 : 1,
            );
            examinations = _.map(
                examinations,
                examination => _.some(registeredExaminations.results, e => e.id === examination.id)
                    ? {...examination, title: '✔ ' + examination.title}
                    : examination,
            );
        }
        this.setState({examinations});
    }

    async save() {
        try {
            let response;
            const id = this.props.store.getIn(['data', 'id']);
            const payload = this.props.mode === 1
                ? {
                    answers: this.state.answers.slice(0, this.props.a4 ? 300 : 120),
                    corrupt: false,
                    type: this.props.a4 ? 14 : 15,
                }
                : {
                    border: this.props.border,
                    page: this.state.page,
                };
            if (this.state.student)
                payload.student = {id: this.state.student.id};
            else
                payload.student = null;
            if (this.state.examination)
                payload.examination = {id: this.state.examination.id};
            else
                payload.examination = null;
            this.context.store.dispatch(actions.setErrors({}, this.props.store.get('elementId')));
            if (id) {
                response = await this.context.store.dispatch(request({
                    path: `/${this.props.mode === 1 ? 'multiple-choice-paper' : 'paper'}/${id}/`,
                    body: payload,
                    method: 'PATCH',
                }));
            }
            else {
                throw 'NO NO NO';
                response = await this.context.store.dispatch(request({
                    path: `/${this.props.mode === 1 ? 'multiple-choice-paper' : 'paper'}/`,
                    body: payload,
                    method: 'POST',
                }));
            }
            this.context.store.dispatch(actions.setData(
                {
                    ...response,
                    image: this.props.store.getIn(['data', 'image']),
                },
                this.props.store.get('elementId'),
            ));
            if (this.props.onManualSaved)
                this.props.onManualSaved(response);
            return true;
        }
        catch (exception) {
            this.context.store.dispatch(actions.setErrors(
                exception,
                this.props.store.get('elementId'),
            ));
            return false;
        }
    }

    render() {
        const rows = this.props.a4 ? 50 : 30;
        const columns = this.props.a4 ? 6 : 4;
        return <span>
            <div
                style={{
                    marginTop: '1em',
                    marginRight: '3em',
                }}>
                <div>
                    <div style={styles.error}>
                        {this.props.store.getIn(['errors', 'non_field_errors'])
                            ? _.map(
                                this.props.store.getIn(['errors', 'non_field_errors']),
                                (error, index) =>
                                    <li
                                        style={{display: 'block'}}
                                        key={index}>
                                        * {error}
                                    </li>,
                            )
                            : null
                        }
                    </div>
                    {window.gettext('Student')}:&nbsp;
                    {this.state.student
                        ? `${this.state.student.firstname} ${this.state.student.lastname} ` +
                            `(${(this.state.student.national_id || '').persian()})`
                        : null
                    }
                    {this.props.readonlyBarcode
                        ? null
                        : <span>
                            <input
                                style={{
                                    ...styles.field,
                                    fontFamily: 'IRANSans',
                                    backgroundColor: this.state.student || !this.props.store.get('data') ? undefined : '#ffefa0',
                                    width: 'calc(100% - 2.5em)',
                                }}
                                ref='studentInput'
                                value={this.state.studentSearch.persian()}
                                onChange={async ({target: {value}}) => {
                                    value = value.english();
                                    this.setState({studentSearch: value});
                                    const self = this;
                                    if(value.length >= 3){
                                        if(self.state.typingTimeout){
                                            clearTimeout(self.state.typingTimeout);
                                        }
                                        self.setState({
                                            studentSearch:value,
                                            typing: false,
                                            typingTimeout: setTimeout(async function () {
                                                const response = await self.context.store.dispatch(request({
                                                    path: `/student/?search=${value.replace(/ /g, ',')}&limit=10`,
                                             }));
                                             if (self.refs.studentInput.value.english() === value)
                                                 self.setState({students: response.results});
                                              }, 1000)
                                         });
                                    }}
                                }
                                onFocus={() => this.setState({studentFocused: true})}
                                onBlur={() => this.setState({studentFocused: false})}
                            />
                            <div
                                style={{
                                    display: 'inline-block',
                                    width: '1.5em',
                                    textAlign: 'center',
                                    pointer: 'cursor',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    window.open('/students/mass_add/');
                                }}>
                                <i className='fa-plus'></i>
                            </div>
                            <div style={{position: 'relative'}}>
                                <div
                                    style={{
                                        display: this.state.studentFocused
                                            ? undefined
                                            : 'none',
                                        position: 'absolute',
                                        backgroundColor: 'white',
                                        width: '100%',
                                        top: '-1em',
                                    }}>
                                    {_.map(
                                        this.state.students,
                                        student => {
                                            const label = `${student.firstname} ${student.lastname} ` +
                                                `(${(student.national_id || '').persian()})`;
                                            return <div
                                                key={student.id}
                                                style={{
                                                    border: '.0625em solid #cccccc',
                                                    cursor: 'pointer',
                                                }}
                                                onMouseDown={event => event.preventDefault()}
                                                onClick={async () => {
                                                    this.setState({
                                                        student,
                                                        examinations: null,
                                                    });
                                                    this.refs.studentInput.blur();
                                                }}>
                                                {label}
                                            </div>;
                                        },
                                    )}
                                </div>
                            </div>
                            <div style={styles.error}>
                                {this.props.store.getIn(['errors', 'student'])
                                    ? _.map(
                                        this.props.store.getIn(['errors', 'student']),
                                        (error, index) =>
                                            <li
                                                style={{display: 'block'}}
                                                key={index}>
                                                * {error}
                                            </li>,
                                    )
                                    : null
                                }
                            </div>
                        </span>
                    }
                </div>
                <div>
                    {window.gettext('Examination')}:&nbsp;
                    {this.props.readonlyBarcode
                        ? this.state.examination
                            ? this.state.examination.title.persian() + ' - ' +  this.state.examination.date.toJalali().persian()
                            : null
                        : <span>
                            <div style={{float: 'left'}}>
                                <Checkbox
                                    checked={this.state.currentYear}
                                    onChange={({target: {checked}}) => this.setState({currentYear: checked})}
                                    label={window.gettext('Current Year')}
                                />
                            </div>
                            {this.state.examinations
                                ? <select
                                    style={{
                                        ...styles.field,
                                        backgroundColor: this.state.examination || !this.props.store.get('data')
                                            ? undefined
                                            : '#ffefa0',
                                        height: '3em',
                                        padding: 0,
                                    }}
                                    value={this.state.examination
                                        ? _.findIndex(this.state.examinations, examination => examination.id === this.state.examination.id)
                                        : 'null'
                                    }
                                    onChange={event => this.setState({
                                        examination: this.state.examinations[event.target.value],
                                    })}>
                                    <option value='null'>---</option>
                                    {_.map(
                                        this.state.examinations,
                                        (examination, index) => <option
                                            key={examination.id}
                                            value={index}>
                                            {examination.title} - {examination.date.toJalali().persian()}
                                        </option>,
                                    )}
                                </select>
                                : <div style={{
                                    ...styles.field,
                                    backgroundColor: this.state.examination ? undefined : '#ffefa0',
                                    height: '3em',
                                    padding: 0,
                                    display: 'inline-block',
                                }}>
                                    <i className='fa-spin fa-spinner'></i>
                                </div>
                            }
                            <div style={styles.error}>
                                {this.props.store.getIn(['errors', 'examination'])
                                    ? _.map(
                                        this.props.store.getIn(['errors', 'examination']),
                                        (error, index) =>
                                            <li
                                                style={{display: 'block'}}
                                                key={index}>
                                                * {error}
                                            </li>,
                                    )
                                    : null
                                }
                            </div>
                        </span>
                    }
                </div>
                {this.props.mode === 2
                    ? <div>
                        {window.gettext('صفحه')}:&nbsp;
                        {this.props.readonlyBarcode
                            ? this.state.page ? (this.state.page + 1).persian() : null
                            : <span>
                                {this.state.examinations
                                    ? <select
                                        style={{
                                            ...styles.field,
                                            backgroundColor: this.state.page || !this.props.store.get('data') ? undefined : '#ffefa0',
                                            height: '3em',
                                            padding: 0,
                                        }}
                                        onChange={event => this.setState({
                                            page: event.target.value,
                                        })}>
                                        <option value='null'>---</option>
                                        {_.map(
                                            new Array(this.state.examination ? this.state.examination.pages : 0),
                                            (__, index) => <option
                                                key={index}
                                                value={index}>
                                                {(index + 1).persian()}
                                            </option>,
                                        )}
                                    </select>
                                    : <div style={{
                                        ...styles.field,
                                        backgroundColor: this.state.page ? undefined : '#ffefa0',
                                        height: '3em',
                                        padding: 0,
                                        display: 'inline-block',
                                    }}>
                                        <i className='fa-spin fa-spinner'></i>
                                    </div>
                                }
                                <div style={styles.error}>
                                    {this.props.store.getIn(['errors', 'examination'])
                                        ? _.map(
                                            this.props.store.getIn(['errors', 'examination']),
                                            (error, index) =>
                                                <li
                                                    style={{display: 'block'}}
                                                    key={index}>
                                                    * {error}
                                                </li>,
                                        )
                                        : null
                                    }
                                </div>
                            </span>
                        }
                    </div>
                    : null
                }
                {!this.props.readonly && this.props.store.getIn(['data', 'id'])
                    ? this.state.student && this.state.examination && (
                        this.props.mode === 1 ||
                        this.state.page && this.props.border
                    )
                        ? <button
                            style={{
                                ...styles.defaultButton,
                                marginLeft: '.125em',
                            }}
                            onClick={this.save.bind(this)}>
                            {window.gettext('Save')}
                        </button>
                        : null
                    : null
                }
                {this.props.loader && this.state.student && this.state.examination
                    ? <button
                        style={{
                            ...styles.defaultButton,
                            backgroundColor: styles.fourthColor,
                            marginLeft: '.125em',
                        }}
                        onClick={() => this.context.store.dispatch(actions.load(
                            {
                                student: this.state.student.id,
                                examination: this.state.examination.id,
                                page: this.props.mode === 1 ? undefined : this.state.page,
                            },
                            this.props.store.get('elementId'),
                        ))}>
                        {window.gettext('Load')}
                    </button>
                    : null
                }
            </div>
            {this.props.mode === 1
                ? _.map(Array(columns), (value, column) => <div
                    key={column}
                    style={{
                        float: 'left',
                        marginTop: this.props.readonlyBarcode ? '4em' : '1em',
                        marginRight: '1.5em',
                        fontSize: '.9em',
                        lineHeight: '1em',
                    }}>
                    {_.map(Array(rows), (value, row) => <div
                        key={row}
                        style={{overflow: 'hidden'}}>
                        <div
                            dir='ltr'
                            style={{
                                width: '1.7em',
                                float: 'left',
                            }}>
                            {(column * rows + row + 1).persian()}.
                        </div>
                        {_.map(Array(this.props.fiveOptions ? 5 : 4), (value, option) => <input
                            key={option}
                            type='checkbox'
                            style={{
                                margin: '.2em',
                                float: 'left',
                            }}
                            readOnly={this.props.readonly}
                            onChange={({target: {checked}}) => {
                                const index = column * rows + row;
                                const current = this.state.answers[index];
                                this.setState(update(
                                    this.state,
                                    {answers: {$splice: [[index, 1, checked
                                        ? (1 << option) | current
                                        : (15 ^ 1 << option) & current]]}},
                                ));
                            }}
                            checked={this.state.answers[
                                column * rows + row
                            ] & (1 << option)}
                        />)}
                    </div>)}
                </div>)
                : _.map(_.sortBy(this.state.answers, 'index'), answer => <div
                    style={{
                        width: '24em',
                        marginBottom: '.5em',
                        marginRight: '1.5em',
                    }}>
                    <img src={imageUrl(answer.image, {
                        width: 384,
                        type: 'orginal-img',
                    })} draggable={false} style={{
                        width: '384px',
                        // height: 0,
                    }}/>
                </div>)
            }
        </span>;
    }
}

export default class Papers extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        pending: PropTypes.number,
    }

    state = {
        automatic: false,
        total: 0,
        processed: 0,
        uploadJobs: [],
        image: this.props.store.getIn(['data', 'image']),
        offset: 0,
        offsetInput: 0,
        magnify: false,
    };

    constructor(props) {
        super(props);
        this.files = [];
        this.readyFiles = [];
        this.pollTimers = {};
        this.uploadSequence = 0;
        this.mounted = false;
        this.loadedOffset = 0;
    }

    componentDidMount() {
        this.mounted = true;
        if (this.refs.directorySelector) {
            this.refs.directorySelector.directory = true;
            this.refs.directorySelector.webkitdirectory = true;
        }
        if (this.props.store.get('data')) {
            this.setState({
                image: this.props.store.getIn(['data', 'image']),
                a4: this.props.store.getIn(['data', 'type']) === 14,
            });
        }
        this.fetch.bind(this)();
    }

    componentWillUnmount() {
        this.mounted = false;
        _.forEach(this.pollTimers, timer => clearTimeout(timer));
        this.pollTimers = {};
        if (this.previewUrl)
            URL.revokeObjectURL(this.previewUrl);
    }

    componentWillUpdate(nextProps, nextState) {
        if (
            (nextProps.store.getIn(['data', 'type']) === 14) !== nextState.a4 &&
            this.state.a4 === nextState.a4 &&
            nextProps.module !== 'reader'
        )
            this.setState({a4: nextProps.store.getIn(['data', 'type']) === 14});
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.refs.directorySelector) {
            this.refs.directorySelector.directory = true;
            this.refs.directorySelector.webkitdirectory = true;
        }
        if (this.props.store.get('data') && (prevProps.store.getIn(['data', 'image']) !== this.props.store.getIn(['data', 'image']))) {
            this.setState({image: this.props.store.getIn(['data', 'image'])});
        }

        if (prevProps.module !== this.props.module) {
            this.setState({offset: 0});
            this.fetch.bind(this)();
        }
        if (this.props.module === 'preview') {
            if (
                prevProps.store.get('student') !== this.props.store.get('student') ||
                prevProps.store.get('examination') !== this.props.store.get('examination') ||
                prevProps.store.get('page') !== this.props.store.get('page') ||
                prevProps.mode !== this.props.mode
            ) {
                this.fetch.bind(this)();
            }
        }
        else if (this.props.module === 'corrupt') {
            if (
                prevState.offset !== this.state.offset ||
                prevProps.mode !== this.props.mode
            ) {
                this.fetch.bind(this)();
            }
        }
    }

    selectFiles(fileList) {
        const files = _.filter(_.map(fileList), file => file.type.startsWith('image/'));
        const directoryFile = _.find(files, file => file.webkitRelativePath);
        this.uploadBatch = directoryFile
            ? {
                id: this.createBatchId(),
                name: directoryFile.webkitRelativePath.split('/')[0],
            }
            : null;
        _.forEach(this.pollTimers, timer => clearTimeout(timer));
        this.pollTimers = {};
        this.files = files;
        this.readyFiles = [];
        this.setState({
            total: files.length,
            processed: 0,
            uploadJobs: [],
            uploadBatch: this.uploadBatch,
        }, () => this.prepareFile());
    }

    createBatchId() {
        if (window.crypto && window.crypto.randomUUID)
            return window.crypto.randomUUID();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
            const random = Math.random() * 16 | 0;
            const value = char === 'x' ? random : ((random & 0x3) | 0x8);
            return value.toString(16);
        });
    }

    fileUploadMetadata(file) {
        if (!this.uploadBatch || !file.webkitRelativePath)
            return {};
        const parts = file.webkitRelativePath.split('/');
        return {
            upload_batch_id: this.uploadBatch.id,
            upload_batch_name: this.uploadBatch.name,
            upload_folder: parts.slice(1, -1).join('/'),
            upload_filename: parts[parts.length - 1],
        };
    }

    async prepareFile() {
        if (this.files.length === 0) {
            this.processFile.bind(this)();
            return;
        }
        let file = this.files.shift();
        this.readyFiles.push(file);
        this.processFile.bind(this)();
        if (this.state.automatic)
            this.prepareFile.bind(this)();
    }

    async processFile() {
        if (this.processing || this.readyFiles.length === 0)
            return;
        if (this.props.mode === 1) {
            await this.processMultipleChoiceFile();
            return;
        }
        this.processing = true;
        this.setState({processing: true});
        const file = this.readyFiles.shift();
        let url = `/${this.props.mode === 1 ? 'multiple-choice-paper' : 'paper'}/read-paper/`;
        let response;
        try {
            response = await this.context.store.dispatch(request({
                path: url,
                body: window.toFormData({
                    image: file,
                    image_content_type: file.type,
                    options: this.state.fiveOptions ? 5 : 4,
                    type: this.state.a4 ? 14 : 15,
                }),
            }));
        }
        catch (exception) {
            alert(exception);
            if(String(this.propsstore.get('examination')).toLowerCase().indexOf('error')!=-1)
            {
                this.readyFiles.push(file);
            }
            this.context.store.dispatch(actions.setData(
                {},
                this.props.store.get('elementId'),
            ));
            this.processing = false;
            this.setState({
                image: file.data,
                processing: false,
            });
        }
        this.setState({
            image: file.data,
            processed: this.state.processed + 1,
        });
        this.context.store.dispatch(actions.setData(
            response,
            this.props.store.get('elementId'),
        ));
        this.processing = false;
        this.setState({processing: false});
        if (this.state.automatic)
            this.processFile.bind(this)();
    }

    errorText(error) {
        if (!error)
            return window.gettext('Unknown error');
        if (typeof error === 'string')
            return error;
        if (error.detail)
            return error.detail;
        const first = _.find(_.values(error), value => value);
        return first instanceof Array ? first.join('، ') : String(first || error);
    }

    updateUploadJob(key, changes) {
        if (!this.mounted)
            return;
        this.setState(state => {
            const uploadJobs = _.map(
                state.uploadJobs,
                job => job.key === key ? {...job, ...changes} : job,
            );
            return {
                uploadJobs,
                processed: _.filter(
                    uploadJobs,
                    job => _.includes(
                        ['succeeded', 'failed', 'rejected', 'deleted'],
                        job.status,
                    ),
                ).length,
            };
        }, () => this.maybeOpenNextCorruptPaper());
    }

    async processMultipleChoiceFile() {
        this.processing = true;
        this.setState({processing: true});
        const file = this.readyFiles.shift();
        const key = ++this.uploadSequence;
        const options = this.state.fiveOptions ? 5 : 4;
        const paperType = this.state.a4 ? 14 : 15;
        const uploadMetadata = this.fileUploadMetadata(file);
        await new Promise(resolve => this.setState(state => ({
            uploadJobs: [...state.uploadJobs, {
                key,
                name: file.name,
                file,
                options,
                paperType,
                status: 'uploading',
                paperId: null,
                error: '',
                batchId: uploadMetadata.upload_batch_id,
                batchName: uploadMetadata.upload_batch_name,
                folder: uploadMetadata.upload_folder,
                relativePath: file.webkitRelativePath || file.name,
            }],
        }), resolve));

        if (this.previewUrl)
            URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = URL.createObjectURL(file);
        this.setState({image: this.previewUrl});

        try {
            const response = await this.context.store.dispatch(backgroundRequest(
                '/multiple-choice-paper/read-paper-async/',
                {
                    method: 'POST',
                    body: window.toFormData({
                        image: file,
                        image_content_type: file.type,
                        options,
                        type: paperType,
                        ...uploadMetadata,
                    }),
                },
            ));
            this.updateUploadJob(key, {
                paperId: response.paper_id,
                taskId: response.task_id,
                status: response.status,
                error: '',
                folder: response.folder,
                batchId: response.batch_id,
                batchName: response.batch_name,
            });
            this.pollPaperStatus(key, response.paper_id);
        }
        catch (exception) {
            this.updateUploadJob(key, {
                status: 'failed',
                error: this.errorText(exception),
            });
        }
        finally {
            this.processing = false;
            if (this.mounted)
                this.setState({processing: false}, () => {
                    if (this.state.automatic)
                        this.prepareFile();
                });
        }
    }

    async pollPaperStatus(key, paperId) {
        if (!this.mounted)
            return;
        let nextPollDelay = 5000;
        try {
            const status = await this.context.store.dispatch(backgroundRequest(
                `/multiple-choice-paper/${paperId}/processing-status/`,
            ));
            this.updateUploadJob(key, {
                status: status.status,
                error: status.error || '',
                attempts: status.attempts,
                corrupt: status.corrupt,
            });
            if (status.status === 'succeeded') {
                delete this.pollTimers[key];
                if (status.corrupt) {
                    if (!this.state.automatic)
                        await this.showPaper(job => job.key === key, true);
                    return;
                }
                if (this.state.automatic)
                    return;
                await this.showPaper(job => job.key === key);
                return;
            }
            if (status.status === 'failed') {
                delete this.pollTimers[key];
                if (!this.state.automatic)
                    await this.showPaper(job => job.key === key, true);
                return;
            }
            // Hundreds of queued papers should not create hundreds of status
            // requests every second. Only the paper currently being processed
            // needs fast feedback; queued jobs are checked less frequently and
            // staggered so their requests do not arrive as one burst.
            nextPollDelay = status.status === 'processing'
                ? 1500
                : 10000 + (key % 10) * 500;
        }
        catch (exception) {
            // A temporary network error must not turn a running server job into
            // a failed one. Keep polling and expose the last connection error.
            this.updateUploadJob(key, {pollError: this.errorText(exception)});
        }
        if (this.mounted) {
            this.pollTimers[key] = setTimeout(
                () => this.pollPaperStatus(key, paperId),
                nextPollDelay,
            );
        }
    }

    async retryUploadJob(job) {
        this.updateUploadJob(job.key, {status: 'uploading', error: '', pollError: ''});
        try {
            if (!job.paperId) {
                const response = await this.context.store.dispatch(backgroundRequest(
                    '/multiple-choice-paper/read-paper-async/',
                    {
                        method: 'POST',
                        body: window.toFormData({
                            image: job.file,
                            image_content_type: job.file.type,
                            options: job.options,
                            type: job.paperType,
                            upload_batch_id: job.batchId,
                            upload_batch_name: job.batchName,
                            upload_folder: job.folder,
                            upload_filename: job.name,
                        }),
                    },
                ));
                this.updateUploadJob(job.key, {
                    paperId: response.paper_id,
                    taskId: response.task_id,
                    status: response.status,
                });
                this.pollPaperStatus(job.key, response.paper_id);
                return;
            }
            const response = await this.context.store.dispatch(backgroundRequest(
                `/multiple-choice-paper/${job.paperId}/retry-processing/`,
                {method: 'POST'},
            ));
            this.updateUploadJob(job.key, {
                status: response.status,
                taskId: response.task_id,
            });
            this.pollPaperStatus(job.key, job.paperId);
        }
        catch (exception) {
            this.updateUploadJob(job.key, {
                status: 'failed',
                error: this.errorText(exception),
            });
        }
    }

    async showPaper(predicate, manualCorrection=false) {
        const job = _.find(this.state.uploadJobs, predicate);
        if (!job || !job.paperId)
            return false;
        const paper = await this.context.store.dispatch(backgroundRequest(
            `/multiple-choice-paper/${job.paperId}/`,
        ));
        if (!this.mounted)
            return false;
        this.context.store.dispatch(actions.setData(
            paper,
            this.props.store.get('elementId'),
        ));
        this.setState({
            image: paper.image,
            manualPaperId: manualCorrection ? paper.id : null,
        });
        return true;
    }

    async maybeOpenNextCorruptPaper() {
        if (
            !this.mounted ||
            this.loadingCorrection ||
            this.state.manualPaperId ||
            this.processing ||
            this.files.length > 0 ||
            this.readyFiles.length > 0 ||
            _.some(
                this.state.uploadJobs,
                job => _.includes(['uploading', 'queued', 'processing'], job.status),
            )
        )
            return;
        const next = _.find(
            this.state.uploadJobs,
            job => !job.corrected && job.paperId && (
                job.status === 'failed' ||
                (job.status === 'succeeded' && job.corrupt)
            ),
        );
        if (!next)
            return;
        this.loadingCorrection = true;
        try {
            await this.showPaper(job => job.key === next.key, true);
        }
        catch (exception) {
            this.updateUploadJob(next.key, {pollError: this.errorText(exception)});
        }
        finally {
            this.loadingCorrection = false;
        }
    }

    manualPaperSaved(paper) {
        this.setState(state => ({
            manualPaperId: null,
            uploadJobs: _.map(
                state.uploadJobs,
                job => job.paperId === paper.id
                    ? {
                        ...job,
                        status: 'succeeded',
                        corrupt: false,
                        corrected: true,
                        error: '',
                    }
                    : job,
            ),
        }), () => this.maybeOpenNextCorruptPaper());
    }

    folderReports() {
        const reports = {};
        _.forEach(this.state.uploadJobs, job => {
            const folder = job.folder || '(ریشه پوشه)';
            if (!reports[folder]) {
                reports[folder] = {
                    folder,
                    total: 0,
                    active: 0,
                    succeeded: 0,
                    corrupt: 0,
                    failed: 0,
                    rejected: 0,
                };
            }
            const report = reports[folder];
            report.total += 1;
            if (_.includes(['uploading', 'queued', 'processing'], job.status))
                report.active += 1;
            else if (job.status === 'rejected' || job.status === 'deleted')
                report.rejected += 1;
            else if (job.status === 'failed')
                report.failed += 1;
            else if (job.status === 'succeeded' && job.corrupt)
                report.corrupt += 1;
            else if (job.status === 'succeeded')
                report.succeeded += 1;
        });
        return _.sortBy(_.values(reports), 'folder');
    }

    async rejectCurrentPaper() {
        const id = this.state.manualPaperId || this.props.store.getIn(['data', 'id']);
        if (!id || !window.confirm('این پاسخ‌برگ رد و از ادامه بررسی خارج شود؟'))
            return false;
        this.setState({rejecting: true});
        try {
            await this.context.store.dispatch(backgroundRequest(
                `/multiple-choice-paper/${id}/reject/`,
                {method: 'POST'},
            ));
            await this.context.store.dispatch(actions.setData(
                undefined,
                this.props.store.get('elementId'),
            ));
            this.setState(state => ({
                image: null,
                manualPaperId: null,
                uploadJobs: _.map(
                    state.uploadJobs,
                    job => job.paperId === id
                        ? {
                            ...job,
                            status: 'rejected',
                            rejected: true,
                            corrected: true,
                            corrupt: false,
                        }
                        : job,
                ),
            }), () => this.maybeOpenNextCorruptPaper());
            return true;
        }
        catch (exception) {
            this.context.store.dispatch(actions.setErrors(
                exception,
                this.props.store.get('elementId'),
            ));
            return false;
        }
        finally {
            if (this.mounted)
                this.setState({rejecting: false});
        }
    }

    async fetch() {
        if (this.props.module === 'reader')
            return;
        const requestedOffset = this.state.offset;
        let url;
        if (this.props.module === 'corrupt')
            url = `/${this.props.mode === 1
                ? 'multiple-choice-paper'
                : 'paper'
            }/?${this.props.mode === 1 ? 'corrupt' : 'examination__isnull'}=True&limit=1&offset=${this.state.offset}&o=-id`;
        else if (this.props.module === 'preview') {
            if (this.props.store.get('student') && this.props.store.get('examination')) {
                url = `/${this.props.mode === 1 ? 'multiple-choice-paper' : 'paper'}/?` +
                    `examination=${this.props.store.get('examination')}&student=${this.props.store.get('student')}`;
                if (this.props.mode === 2) {
                    if (this.props.store.get('page'))
                        url += '&page=' + this.props.store.get('page');
                    else
                        return;
                }
            }
            else {
                return;
            }
        }
        this.setState({fetching: true});
        try {
            const response = await this.context.store.dispatch(
                this.props.module === 'corrupt'
                    ? backgroundRequest(url)
                    : request(url),
            );
            if (!this.mounted)
                return;
            const paper = response.results[0];
            this.context.store.dispatch(actions.setData(
                paper,
                this.props.store.get('elementId'),
            ));
            this.loadedOffset = requestedOffset;
            this.setState({
                total: response.count,
                processed: 0,
                offsetInput: response.count - requestedOffset,
                image: paper ? paper.image : null,
            });
        }
        catch (exception) {
            if (this.mounted) {
                this.context.store.dispatch(actions.setErrors(
                    exception,
                    this.props.store.get('elementId'),
                ));
            }
        }
        finally {
            if (this.mounted)
                this.setState({fetching: false});
        }
    }

    async remove() {
        if (!this.props.store.getIn(['data', 'id'])) {
            return false;
        }
        if (!window.confirm(window.gettext('Are you sure you' +
            ' wanna remove this paper?')))
            return false;
        this.setState({removing: true});
        try {
            const id = this.props.store.getIn(['data', 'id']);
            await this.context.store.dispatch(backgroundRequest(
                `/${this.props.mode === 1 ? 'multiple-choice-paper' : 'paper'}/${id}/`,
                {method: 'DELETE'},
            ));
            await this.context.store.dispatch(actions.setData(
                undefined,
                this.props.store.get('elementId'),
            ));
            this.setState(state => ({
                total: Math.max(0, state.total - 1),
                image: null,
                manualPaperId: state.manualPaperId === id
                    ? null
                    : state.manualPaperId,
                uploadJobs: _.map(
                    state.uploadJobs,
                    job => job.paperId === id
                        ? {...job, corrected: true, status: 'deleted', corrupt: false}
                        : job,
                ),
            }), () => {
                if (this.props.module === 'reader')
                    this.maybeOpenNextCorruptPaper();
                else
                    this.next();
            });
            return true;
        }
        catch (exception) {
            this.context.store.dispatch(actions.setErrors(
                exception,
                this.props.store.get('elementId'),
            ));
            return false;
        }
        finally {
            this.setState({removing: false});
        }
    }

    next() {
        if (this.props.module === 'reader')
            this.prepareFile.bind(this)();
        else if (this.props.module === 'corrupt')
            this.fetch.bind(this)();
    }
    archive() {
        const id = this.props.store.getIn(['data', 'id']);
        if (this.props.module === 'corrupt') {
            this.context.store.dispatch(request({
                path: `/archiveMultipleChoicePaper/`,
                body: {id: id},
            })); 
            this.fetch.bind(this)();
        }
    }

    render() {
        const currentPaper = this.props.store.get('data');
        const currentFolder = currentPaper && currentPaper.get
            ? currentPaper.get('upload_folder') || currentPaper.get('upload_batch_name')
            : null;
        const currentFilename = currentPaper && currentPaper.get
            ? currentPaper.get('upload_filename')
            : null;
        const folderReports = this.folderReports();
        const activeUploadJobs = _.filter(
            this.state.uploadJobs,
            job => _.includes(['uploading', 'queued', 'processing'], job.status),
        );
        const failedUploadJobs = _.filter(
            this.state.uploadJobs,
            job => job.status === 'failed' && !job.paperId,
        );
        const corruptUploadJobs = _.filter(
            this.state.uploadJobs,
            job => !job.corrected && (
                job.status === 'failed' ||
                (job.status === 'succeeded' && job.corrupt)
            ),
        );
        const succeededUploadJobs = _.filter(
            this.state.uploadJobs,
            job => job.status === 'succeeded' && !job.corrupt,
        );
        return <span>
            <div style={{overflow: 'hidden'}}>
                {(
                    this.props.module === 'reader' &&
                    !this.context.pending &&
                    !this.state.manualPaperId &&
                    activeUploadJobs.length === 0
                )
                    ? <Checkbox
                        style={{
                            ...styles.button,
                            float: 'right',
                            margin: '.25em',
                            backgroundColor: this.state.automatic
                                ? 'a0a0a0'
                                : styles.button.backgroundColor,
                        }}
                        label={window.gettext('Automatic')}
                        checked={this.state.automatic}
                        onClick={() => {
                            const automatic = !this.state.automatic;
                            this.setState({automatic});
                            if (automatic) {
                                this.prepareFile.bind(this)();
                            }
                        }}
                    />
                    : null
                }
                {(
                    this.props.module === 'reader' &&
                    this.props.store.getIn(['data', 'id']) &&
                    this.props.store.getIn(['data', 'upload_batch_id'])
                )
                    ? this.state.rejecting
                        ? <i style={{float: 'right'}} className='fa-spin fa-spinner fa-2x'></i>
                        : <button
                            style={{
                                ...styles.mark_errorButton,
                                float: 'right',
                                margin: '.25em',
                            }}
                            onClick={this.rejectCurrentPaper.bind(this)}>
                            رد برگه
                        </button>
                    : null
                }
                {(
                    this.props.module === 'corrupt' &&
                    this.props.store.get('data')
                )
                    ? this.state.fetching || this.state.processing
                        ? <i style={{float: 'right'}} className='fa-spin fa-spinner fa-2x'></i>
                        : <button
                            style={{
                                ...styles.mark_errorButton,
                                float: 'right',
                                margin: '.25em',
                            }}
                            onClick={() => {
                                this.archive();
                            }}>
                                آرشیو
                        </button>
                    : null
                }
                {(
                    this.props.module === 'reader' &&
                    !this.state.automatic &&
                    this.readyFiles.length + this.files.length > 0 &&
                    !this.context.pending &&
                    activeUploadJobs.length === 0
                ) || (
                    this.props.module === 'corrupt' &&
                    this.props.store.get('data')
                )
                    ? this.state.fetching || this.state.processing
                        ? <i style={{float: 'right'}} className='fa-spin fa-spinner fa-2x'></i>
                        : <button
                            style={{
                                ...styles.defaultButton,
                                float: 'right',
                                margin: '.25em',
                            }}
                            onClick={() => {
                                if (this.props.module === 'corrupt' && this.props.store.get('data'))
                                        this.setState({offset: this.loadedOffset + 1});
                                else
                                    this.next.bind(this)();
                            }}>
                            {(
                                this.props.store.getIn(['data', 'student']) &&
                                this.props.store.getIn(['data', 'examination']) &&
                                !this.props.store.getIn(['data', 'corrupt'])
                            ) ? window.gettext('Next') : window.gettext('Ignore')
                            }
                        </button>
                    : null
                }
                {this.props.store.get('data') && !this.state.automatic
                    ? this.state.removing
                        ? <i style={{float: 'right'}} className='fa-spin fa-spinner fa-2x'></i>
                        : <button
                            style={{
                                ...styles.button,
                                float: 'right',
                                margin: '.25em',
                            }}
                            onClick={this.remove.bind(this)}>
                            {window.gettext('Remove')}
                        </button>
                    : null
                }
                {this.state.processing
                    ? <i style={{float: 'right'}} className='fa-spin fa-spinner fa-2x'></i>
                    : <span>
                        {
                            this.files.length === 0 &&
                            activeUploadJobs.length === 0 &&
                            corruptUploadJobs.length === 0 &&
                            !this.state.manualPaperId &&
                            this.props.module === 'reader'
                            ? <>
                                <input
                                    type='file'
                                    key='fileSelector'
                                    ref='fileSelector'
                                    multiple
                                    accept='image/*'
                                    style={{display: 'none'}}
                                    onClick={() => {
                                        this.refs.fileSelector.value = '';
                                        this.refs.directorySelector.value = '';
                                    }}
                                    onChange={() => {
                                        this.selectFiles(this.refs.fileSelector.files);
                                    }}
                                />
                                <input
                                    type='file'
                                    key='directorySelector'
                                    ref='directorySelector'
                                    style={{display: 'none'}}
                                    accept='image/*'
                                    disabled={this.files.length > 0}
                                    onClick={() => {
                                        this.refs.fileSelector.value = '';
                                        this.refs.directorySelector.value = '';
                                    }}
                                    onChange={() => {
                                        this.selectFiles(this.refs.directorySelector.files);
                                    }}
                                />
                                <button
                                    key='file'
                                    style={{
                                        ...styles.button,
                                        float: 'right',
                                        margin: '.25em',
                                    }}
                                    onClick={() => this.refs.fileSelector.click()}>
                                    {window.gettext('Upload Files')}
                                </button>
                                <button
                                    key='directory'
                                    style={{
                                        ...styles.defaultButton,
                                        float: 'right',
                                        margin: '.25em',
                                    }}
                                    onClick={() => this.refs.directorySelector.click()}>
                                    آپلود پوشه‌بندی‌شده
                                </button>
                            </>
                            : null
                        }
                        {this.props.mode === 1
                            ? <Checkbox
                                checked={this.state.fiveOptions}
                                onChange={({target: {checked}}) => this.setState({fiveOptions: checked})}
                                label={window.gettext('Five Options')}
                            />
                            : null
                        }
                        {this.props.mode === 1
                            ? <Checkbox
                                checked={this.state.a4}
                                onChange={({target: {checked}}) => this.setState({a4: checked})}
                                label='A4'
                            />
                            : null
                        }
                    </span>
                }
                {(this.props.module === 'reader' && this.state.total > 0) || this.props.module === 'corrupt'
                    ? <div
                        style={{
                            float: 'left',
                        }}>
                        {this.props.module === 'corrupt'
                            ? <input
                                style={{...styles.field, width: '4em'}}
                                value={this.state.offsetInput.persian()}
                                onKeyDown={
                                    event => {
                                        if(this.context.pending){
                                            event.preventDefault();
                                            return false;
                                        }
                                    }
                                }
                                onKeyPress={
                                    event => {
                                        if(this.context.pending){
                                            event.preventDefault();
                                            return false;
                                        }
                                        else 
                                        {
                                            if ((event.keyCode || event.charCode) == 13) {
                                                this.setState({
                                                    offset: this.state.total - this.state.offsetInput,
                                                });
                                            }
                                        }
                                    }
                                }
                                onChange={({target: {value}}) => {
                                    value = value.english();
                                    if (isNaN(Number.parseInt(value)) && value.length > 0)
                                        return;
                                    if (Number.parseInt(value) > this.state.total)
                                        return;
                                    if (Number.parseInt(value) < 1)
                                        return;
                                    this.setState({
                                        offsetInput: isNaN(Number.parseInt(value)) ? '' : value,
                                    });
                                }}
                            />
                            : null
                        }
                        &nbsp;
                        {this.state.processed > 0
                            ? <span>
                                {this.state.processed.persian()}&nbsp;
                                {window.gettext('from')}&nbsp;
                            </span>
                            : <span>{window.gettext('Remaining')}:&nbsp;</span>
                        }
                        {this.state.total.persian()}&nbsp;
                        {this.state.processed > 0
                            ? <progress
                                value={this.state.processed}
                                max={this.state.total}
                            />
                            : null
                        }
                    </div>
                    : null
                }
                {this.props.module === 'reader' && this.props.mode === 1 && this.state.uploadJobs.length > 0
                    ? <div style={{clear: 'both', padding: '.5em 0'}}>
                        <span style={{marginLeft: '1em'}}>
                            در صف/پردازش: {activeUploadJobs.length.persian()}
                        </span>
                        <span style={{marginLeft: '1em', color: '#16833b'}}>
                            موفق: {succeededUploadJobs.length.persian()}
                        </span>
                        <span style={{marginLeft: '1em', color: corruptUploadJobs.length ? '#a66000' : undefined}}>
                            خراب/در انتظار اصلاح: {corruptUploadJobs.length.persian()}
                        </span>
                        <span style={{color: failedUploadJobs.length ? '#b00020' : undefined}}>
                            ناموفق: {failedUploadJobs.length.persian()}
                        </span>
                        {_.map(_.filter(failedUploadJobs, job => !job.paperId), job => <div
                            key={job.key}
                            style={{
                                marginTop: '.5em',
                                padding: '.5em',
                                color: '#b00020',
                                backgroundColor: '#fff2f2',
                                borderRadius: styles.button.borderRadius,
                            }}>
                            <span>{job.name}: {job.error || 'پردازش ناموفق بود.'}</span>
                            <button
                                style={{...styles.defaultButton, marginRight: '1em'}}
                                onClick={() => this.retryUploadJob(job)}>
                                تلاش مجدد
                            </button>
                        </div>)}
                    </div>
                    : null
                }
                {this.state.uploadBatch && this.state.uploadJobs.length > 0
                    ? <div style={{clear: 'both', paddingTop: '.5em'}}>
                        <div style={{
                            margin: '.5em 0',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontSize: '1.1em',
                        }}>
                            گزارش پوشه‌ها: {this.state.uploadBatch.name}
                        </div>
                        <table style={{width: '100%', textAlign: 'center'}}>
                            <thead>
                                <tr>
                                    <th>پوشه</th>
                                    <th>کل</th>
                                    <th>در حال پردازش</th>
                                    <th>موفق</th>
                                    <th>خراب</th>
                                    <th>ناموفق</th>
                                    <th>ردشده</th>
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(folderReports, report => <tr key={report.folder}>
                                    <td>{report.folder}</td>
                                    <td>{report.total.persian()}</td>
                                    <td>{report.active.persian()}</td>
                                    <td>{report.succeeded.persian()}</td>
                                    <td>{report.corrupt.persian()}</td>
                                    <td>{report.failed.persian()}</td>
                                    <td>{report.rejected.persian()}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                    : null
                }
            </div>
            {currentFolder
                ? <div style={{
                    clear: 'both',
                    padding: '.65em 1em',
                    margin: '.75em 0',
                    backgroundColor: '#eef6ff',
                    borderRadius: styles.button.borderRadius,
                }}>
                    <strong>پوشه: {currentFolder}</strong>
                    {currentFilename ? <span> — فایل: {currentFilename}</span> : null}
                </div>
                : null
            }
            <div
                style={{
                    float: 'left',
                    minWidth: '30em',
                    minHeight: '1px',
                    marginRight: '-1em',
                }}>
                {this.props.store.get('data') || this.props.module === 'preview'
                    ? <Paper
                        {...this.props}
                        readonly={this.state.automatic && !this.state.manualPaperId}
                        readonlyBarcode={this.props.module === 'reader' && !this.state.manualPaperId}
                        loader={this.props.module === 'preview'}
                        border={this.state.border}
                        fiveOptions={this.state.fiveOptions}
                        a4={this.state.a4}
                        onManualSaved={this.manualPaperSaved.bind(this)}
                    />
                    : this.props.store.get('data') === null
                        ? <i className='fa-spin fa-spinner fa-2x'></i>
                        : null
                }
            </div>
            <div style={{float: 'left', position: 'relative'}}>
                {this.state.image
                    ? <img
                        style={{
                            height: this.state.magnify ? '60em' : '46em',
                            cursor: this.state.magnify ? '-webkit-zoom-out' : '-webkit-zoom-in',
                        }}
                        draggable='false'
                        src={this.state.image.length === 32
                            ? imageUrl(this.state.image, {
                                height: this.state.magnify ? 960 : this.props.module === 'corrupt' ? 500 : 608,
                                type: 'contain',
                            })
                            : this.state.image
                        }
                        onMouseDown={event => {
                            if (event.button !== 0)
                                return;
                            const node = event.currentTarget;
                            const rect = node.getBoundingClientRect();
                            const border = this.refs.border;
                            const originX = event.clientX;
                            const originY = event.clientY;
                            let initiated = false;
                            const mouseMoveHandler = event => {
                                if (this.props.mode === 1)
                                    return;
                                if (Math.abs(event.clientX - originX) + Math.abs(event.clientY - originY) < 5)
                                    return;
                                if (!initiated) {
                                    initiated = true;
                                    border.style.width = '1px';
                                    border.style.height = '1px';
                                    border.style.left = event.clientX - rect.left + 'px';
                                    border.style.top = event.clientY - rect.top + 'px';
                                }
                                border.style.width = Math.abs(event.clientX - originX) + 'px';
                                border.style.height = Math.abs(event.clientY - originY) + 'px';
                                if (event.clientX < originX)
                                    border.style.left = event.clientX - rect.left + 'px';
                                if (event.clientY < originY)
                                    border.style.top = event.clientY - rect.top + 'px';
                            };
                            const mouseUpHandler = event => {
                                if (Math.abs(event.clientX - originX) + Math.abs(event.clientY - originY) >= 5 && this.props.mode !== 1) {
                                    border.style.width = Math.abs(event.clientX - originX) + 'px';
                                    border.style.height = Math.abs(event.clientY - originY) + 'px';
                                    if (event.clientX < originX)
                                        border.style.left = event.clientX - rect.left + 'px';
                                    if (event.clientY < originY)
                                        border.style.top = event.clientY - rect.top + 'px';
                                    this.setState({border: {
                                        top: Number.parseInt(border.style.top) / node.clientHeight,
                                        left: Number.parseInt(border.style.left) / node.clientWidth,
                                        width: Number.parseInt(border.style.width) / node.clientWidth,
                                        height: Number.parseInt(border.style.height) / node.clientHeight,
                                    }});
                                }
                                else {
                                    this.setState({magnify: !this.state.magnify});
                                }
                                document.removeEventListener('mousemove', mouseMoveHandler, true);
                                document.removeEventListener('mouseup', mouseUpHandler, true);
                            };
                            document.addEventListener('mousemove', mouseMoveHandler, true);
                            document.addEventListener('mouseup', mouseUpHandler, true);
                        }}
                    />
                    : null
                }
                <div
                    ref='border'
                    style={{
                        border: '.0625em solid black',
                        boxSizing: 'border-box',
                        position: 'absolute',
                        pointerEvents: 'none',
                    }}>
                </div>
            </div>
        </span>;
    }
}
